/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для формы сообщения директору в личном кабинете
   */
  app.MessageToDirectorFormView = app.MessageFormView.extend({
    el: '#director_message',
    formName: 'director-message',
    modelName: 'Message',
    /**
     * @param int Тип: сообщение менеджеру
     */
    type: 2
  });
})();

}.call(window));